import RepositoryService from 'src/services/repository'

const resource = 'multiTask/settings'

async function get () {
  const response = await RepositoryService.base.get(resource)
  return response?.data ?? response
}

async function patch (data) {
  const response = await RepositoryService.base.patch(resource, data)
  return response?.data ?? response
}

export default {
  get,
  patch,
}
